import * as angular from "angular";
import "./externalReferenceRecord.dialog.scss";
import { IExternalReference, IExternalReferenceType } from "../externalReferences.interfaces";
import { ExternalReferenceService } from "../externalReference.service";
import { TranslationService } from "@services/translation.service";

class ExternalReferenceRecordComponentController implements angular.IComponentController {

    loading: boolean = true;
    saving = false;
    errorMessage: string;
    externalReference: IExternalReference;
    externalReferenceTypes: IExternalReferenceType[] = [];
    externalReferenceType: IExternalReferenceType;
    showExternalReferenceType = false;

    static $inject = ["$mdDialog", "externalReferenceService", "translationService"];

    constructor(
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly externalReferenceService: ExternalReferenceService,
        private readonly translationService: TranslationService    ) {
    }

    $onInit() {
        this.externalReferenceService.initExternalRefChangeFields();
        this.externalReferenceService.getExternalTypes().then(results => {
            this.externalReferenceTypes = results;

            if (!this.externalReferenceTypes.any()) {
                this.showExternalReferenceType = true;
            }

            if (this.externalReference.Id === 0 && this.externalReferenceTypes.any()) {
                this.externalReference.ExternalReferenceTypeId = this.externalReferenceTypes.firstOrDefault<IExternalReferenceType>().Id;
            }

            this.loading = false;
        });
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.clearErrorMessage();

        if (this.hasSpecialCharacters(this.externalReference.ExternalReference)) {
            return;
        }

        this.externalReferenceService.validateExternalReference(this.externalReference).then(response => {
            if (!response?.Success) {
                this.errorMessage = response?.Message;
            }
        });
    }

    deleteRecord() {
        this.saving = true;
        this.externalReferenceService.deleteReference(this.externalReference).finally(() => {
            this.$mdDialog.hide();
            this.saving = false;
        });
    }

    cancel() {
        this.externalReference = null;
        this.$mdDialog.hide();
    }

    saveRecord($event: MouseEvent) {
        this.saving = true;
        this.externalReferenceService
            .updateExternalReferenceType(this.externalReferenceType).then(typeId => {

                if (typeId) {
                    this.externalReference.ExternalReferenceTypeId = typeId;
                }

                if (!this.externalReference.externalReferenceType) {
                    const extRefType = this.externalReferenceTypes.firstOrDefault<IExternalReferenceType>(x => x.Id == this.externalReference.ExternalReferenceTypeId);
                    this.externalReference.externalReferenceType = extRefType ? angular.copy(extRefType) : null;
                }

                this.externalReferenceService.updateReference(this.externalReference)
                    .then((response) => {
                        this.saving = false;
                        if (response.Success) {
                            this.$mdDialog.hide();
                        } else {
                            this.errorMessage = response.Message;
                        }
                    });
            });
    }

    cancelAddNewReferenceType() {
        this.showExternalReferenceType = false;
        this.externalReferenceType = null;
    }

    showNewReferenceTypeDialog(ev: MouseEvent) {
        this.externalReferenceType = { Type: "" };
        this.showExternalReferenceType = true;
    }

    private hasSpecialCharacters(input: string): boolean {
        const specialCharacters: string[] = ["/", ".", ":", "%", "*"];
        const foundedSC: string[] = specialCharacters.filter(character => input?.indexOf(character) > -1);
        const hasSpecialCharacters: boolean = foundedSC?.length > 0;

        this.errorMessage = (hasSpecialCharacters) ? this.translationService.t(`externalReferenceRecord.notContainMessage`, foundedSC.join(' ')) : null;

        return hasSpecialCharacters;
    }

    private clearErrorMessage(): void {
        this.errorMessage = null;
    }
}

export class ExternalReferenceRecordComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: any;

    constructor() {
        this.bindings = {
            externalReference: "="
        };

        this.controller = ExternalReferenceRecordComponentController;
        this.template = require("./externalReferenceRecord.html");
    }
}
